export function on(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.addEventListener) {
        obj.addEventListener.apply(obj, args);
    }
}
export function off(obj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (obj && obj.removeEventListener) {
        obj.removeEventListener.apply(obj, args);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var hasOwnProperty = function (obj, property) { return Object.prototype.hasOwnProperty.call(obj, property); };
export var yieldTrue = function () { return true; };
export var yieldFalse = function () { return false; };
